
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5 4.044a7.661 7.661 0 0 0 .28 1.612l-.744.744a9.225 9.225 0 0 1-.473-2.358H5m6.135 7.479a7.935 7.935 0 0 0 1.618.28v.927a9.6 9.6 0 0 1-2.364-.467l.747-.74M5.6 2.8H3.422a.624.624 0 0 0-.622.622A10.577 10.577 0 0 0 13.378 14a.624.624 0 0 0 .622-.622v-2.172a.624.624 0 0 0-.622-.622 7.1 7.1 0 0 1-2.221-.355.522.522 0 0 0-.193-.031.637.637 0 0 0-.442.18l-1.369 1.37a9.426 9.426 0 0 1-4.1-4.1l1.368-1.37a.624.624 0 0 0 .156-.635 7.069 7.069 0 0 1-.355-2.221A.624.624 0 0 0 5.6 2.8z"}})])
          )
        }
      }
    